import { createSelector } from 'reselect';

export const selectAppointment = ({ appointment }) =>
  appointment.appointment ? appointment.appointment : undefined;

export const selectAppointmentType = createSelector(
  selectAppointment,
  ({ appointmentType } = {}) => appointmentType,
);

export const selectRelatedAppointments = createSelector(
  selectAppointment,
  ({ relatedAppointments = [] } = {}) => relatedAppointments,
);

export const selectRelatedAppointmentTypeId = (relatedAppointmentTypeId) =>
  createSelector(selectRelatedAppointments, (relatedTreatments) =>
    relatedTreatments.find(
      (relatedTreatment) => relatedTreatment.appointmentType.id === relatedAppointmentTypeId,
    ),
  );

export const selectAppointmentCategoryImage = createSelector(
  selectAppointmentType,
  ({ imageUrl } = {}) => imageUrl,
);

export const selectAppointmentPartner = createSelector(
  selectAppointment,
  ({ partner } = {}) => partner,
);

export const selectAppointmentDateSlot = createSelector(selectAppointment, ({ date } = {}) => date);

export const selectAppointmentTimeSlot = createSelector(
  selectAppointment,
  (appointment) => appointment?.time,
);

export const selectAppointmentTypePrice = createSelector(
  selectAppointment,
  ({ price = '' } = {}) => price,
);

export const selectProducts = createSelector(
  selectAppointment,
  ({ products = [] } = {}) => products,
);

export const selectStoreId = createSelector(selectAppointment, ({ storeId = '' } = {}) => storeId);

export const selectEventId = createSelector(selectAppointment, ({ eventId = '' } = {}) => eventId);

export const selectAddress = createSelector(selectAppointment, ({ address = {} } = {}) => address);

export const appointmentSelectors = {
  selectAppointment,
  selectAppointmentType,
  selectProducts,
  selectStoreId,
  selectAppointmentCategoryImage,
  selectAppointmentPartner,
  selectAppointmentTypePrice,
  selectAppointmentDateSlot,
  selectAppointmentTimeSlot,
  selectRelatedAppointments,
  selectEventId,
  selectAddress,
};
